import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["readonly", "id", "placeholder", "disabled", "value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("textarea", {
            class: "form-control",
            rows: "3",
            ref: "inputElem",
            readonly: _ctx.readonly,
            id: _ctx.id,
            placeholder: _ctx.placeHolder,
            disabled: _ctx.disabled,
            onInput: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            onKeydown: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
            value: _ctx.modelValue
        }, null, 40, _hoisted_1),
        _createVNode(_component_FormElementDescription, { description: _ctx.description }, null, 8, ["description"])
    ]));
}
